export default "__VITE_ASSET__B4Zj5yGA__"